import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ToolSearchParams } from 'src/app/shared/models/toolSearchParams';
import { ToolsService } from 'src/app/service/tools/tools.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { ToolTransferService } from '../tool-transfer.service';
import { SelectedDataModel, PaginationModel } from '../tool-transfer.model';
import { assignment } from '../tool-transfer.functions';
@Component({
  selector: 'app-tool-transfer-search',
  templateUrl: './tool-transfer-search.component.html',
  styleUrls: ['./tool-transfer-search.component.scss'],
})
export class ToolTransferSearchComponent implements OnInit, OnDestroy {
  @ViewChild('searchinput') searchinput: ElementRef;

  search: '';
  searchSubject = new BehaviorSubject<string>(null);

  searchResults: Array<SelectedDataModel> = [];
  searchPagination: PaginationModel;
  searchParams: ToolSearchParams = {
    page: 1,
    limit: 10,
    cache: 'clear',
    embed: 'assignment,alert,model,vehicleDetail',
    searchFields: this.searchFields,
    // attributes:'id,toolId,initialMileageHours,description,serialNumber,model.id|name,assignment.id|assignedDate', fields: 'toolId,description,serialNumber,model.category.name,model.category.assetClass.name,model.manufacturer.name,assignment.type.name,assignment.job.name,assignment.owner.owner_name,assignment.shopLocation.name,assignment.vendor.company_name,assignment.employee.first_name,assignment.employee.last_name,assignment.employee.employee_alias,assignment.assigned_date'
  };

  get searchFields() {
    const fields = [
      'toolId',
      'description',
      'lastMileageHours',
      'serialNumber',
      'model.name',
      'model.description',
      'model.category.name',
      'model.category.assetClass.name',
      'model.manufacturer.name',
      'assignment.assigned_date',
      'assignment.type.name',
      'assignment.job.name',
      'assignment.owner.owner_name',
      'assignment.shopLocation.name',
      'assignment.vendor.company_name',
      'assignment.employee.first_name',
      'assignment.employee.last_name',
      'assignment.employee.employee_alias',
      'assignment.responsibleParty.first_name',
      'assignment.responsibleParty.last_name',
      'assignment.responsibleParty.employee_alias',
      'vehicleDetail.license_plate',
      'assignment.facility.facility_name',
    ];
    return fields.join(',');
  }
  searchResultsAreVisible: boolean = false;
  activeIndex: number = 0;
  selectedItems: Array<SelectedDataModel> = [];

  searchIgnoreKeys = ['Escape', 'ArrowDown', 'ArrowUp', 'Enter'];

  subscription: Subscription;

  constructor(
    private toolsService: ToolsService,
    private toolTransferService: ToolTransferService,
  ) {}

  ngOnInit(): void {
    this.subscription = this.toolTransferService.selectedItems.subscribe(data => {
      this.selectedItems = data;
    });

    this.searchSubject
      .pipe(
        filter(value => value !== null),
        debounceTime(500),
        distinctUntilChanged(),
      )
      .subscribe((search: string) => {
        this.searchParams = { ...this.searchParams, page: 1, search };
        this.toolsService.read['tools'](this.searchParams).subscribe(res => {
          this.searchResults = res.data;
          this.searchPagination = res.pagination;
          this.showResults();
          this.selectItems();
          this.resetActiveIndex();
        });
      });
  }

  ngAfterViewInit() {
    // this.focusSearchInput();
  }

  ngOnDestroy(): void {
    this.searchSubject.unsubscribe();
  }

  fetchNext(page: number, event: MouseEvent) {
    event.preventDefault();
    this.searchParams = { ...this.searchParams, page };
    this.toolsService.read['tools'](this.searchParams).subscribe(res => {
      this.searchResults = [...this.searchResults, ...res.data];
      this.searchPagination = res.pagination;
      this.selectItems();
    });
  }

  handleSearch(event: KeyboardEvent) {
    const { value } = <HTMLInputElement>event.target;
    if (this.searchIgnoreKeys.includes(event.key)) return;
    this.searchSubject.next(value);
  }

  handleSelect(currentIndex: number = -1) {
    this.search = '';
    if (currentIndex > -1) {
      this.activeIndex = currentIndex;
    }
    const selectedItem = this.searchResults[this.activeIndex];
    if (!selectedItem.selected) {
      this.searchResults[this.activeIndex].selected = true;
      this.toolTransferService.add(selectedItem);
      this.hideResults();
    } else {
      this.searchResults[this.activeIndex].selected = false;
      this.toolTransferService.remove(selectedItem.id as number);
    }
  }

  handleTraverseUp() {
    if (this.activeIndex > 0) {
      this.activeIndex--;
      this.scrollIntoView('end');
    }
  }

  handleTraverseDown() {
    if (this.activeIndex < this.searchResults.length - 1) {
      this.activeIndex++;
      this.scrollIntoView('start');
    }
  }

  selectItems() {
    this.selectedItems.forEach((item: SelectedDataModel) => {
      const index = this.searchResults.findIndex(row => row.id === item.id);
      if (this.searchResults[index]) {
        this.searchResults[index].selected = true;
      }
    });
  }

  deselectItem(id: number) {
    const index = this.searchResults.findIndex(item => item.id === id);
    if (this.searchResults[index]) {
      this.searchResults[index].selected = false;
    }
  }

  resetActiveIndex() {
    this.activeIndex = 0;
    this.scrollIntoView('end');
  }

  showResults() {
    if (this.searchResults.length) {
      this.searchResultsAreVisible = true;
    }
  }

  hideResults() {
    this.searchResultsAreVisible = false;
  }

  scrollIntoView(block: ScrollLogicalPosition) {
    const element = document.querySelector('tr.is-active');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block });
    }
  }

  focusSearchInput() {
    this.searchinput.nativeElement.focus();
  }

  getPrimaryAssignment(row: any) {
    return assignment(row, 'primaryAssignment');
  }

  getAssignmentType(row: any) {
    return assignment(row, 'type.name');
  }
}
